import { ISearchVirkesleverantor } from "../../../virkeskop/virkesleverantor/models/virkesleverantorModel";
import { PhoneFormatter } from "../../utils/phone-formatter";

export class LeverantorListItem {

    telefon: string;
    get namn() { return this.model.namn ?? `${this.model.fornamn} ${this.model.efternamn}`; }
    get adress() { return this.model.adress ?? this.model.adress2; }
    get orgnr() { return this.model.orgnr; }
    get limeId() { return this.model.limeId; }

    model: ISearchVirkesleverantor;
    checked: boolean;

    constructor(leverantor: ISearchVirkesleverantor) {
        this.model = leverantor;
        this.checked = false;
        this.telefon = PhoneFormatter.renderPhonePresentation([
            this.model.mobil,
            this.model.telefon
        ]);
    }
}
